import modelService from '@/services/ModelService';
import { Model } from '@/models/Model';

export enum SourceType {
  GITHUB = 'GITHUB',
  BITBUCKET = 'BITBUCKET',
  CONFLUENCE = 'CONFLUENCE',
  GDRIVE = 'GDRIVE',
}

export enum ConnectorStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  PAUSED = 'PAUSED',
  ERROR = 'ERROR',
  DISCONNECTING = 'DISCONNECTING',
  DISCONNECTED = 'DISCONNECTED',
}

export interface IResourceSelectionItem {
  externalId: string;
  resourcePath: string;
  resourceType: string;
  branch?: string;
}

export interface ConnectorCreatedByUser {
  firstName?: string;
  lastName?: string;
  email?: string;
  profileImage?: string;
}

export class ConnectorConfig implements Model {
  id: string | null = null;
  workspace: string | null = null;
  sourceType: SourceType | null = null;
  name: string | null = null;
  status: ConnectorStatus | null = null;
  lastSyncAt: Date | null = null;
  lastSyncError: string | null = null;
  syncIntervalMinutes = 60;
  resourceSelection: { items: IResourceSelectionItem[] } = { items: [] };
  createdAt: Date | null = null;
  updatedAt: Date | null = null;
  createdBy: string | null = null;
  createdByUser: ConnectorCreatedByUser | null = null;
  consecutiveFailures = 0;

  static parse(jsonData: unknown): ConnectorConfig {
    return modelService.create(ConnectorConfig, jsonData);
  }

  afterLoad(data: any): void {
    this.id = data._id || data.id || null;
    this.workspace = data.workspace || null;
    this.lastSyncAt = data.lastSyncAt ? new Date(data.lastSyncAt) : null;
    this.lastSyncError = data.lastSyncError || null;
    this.createdAt = data.createdAt ? new Date(data.createdAt) : null;
    this.updatedAt = data.updatedAt ? new Date(data.updatedAt) : null;
    this.consecutiveFailures = data.consecutiveFailures || 0;
    this.resourceSelection = data.resourceSelection || { items: [] };

    if (data.createdBy && typeof data.createdBy === 'object') {
      this.createdBy = data.createdBy._id || data.createdBy.id || null;
      this.createdByUser = {
        firstName: data.createdBy.firstName,
        lastName: data.createdBy.lastName,
        email: data.createdBy.email,
        profileImage: data.createdBy.profileImage,
      };
    } else {
      this.createdBy = data.createdBy || null;
      this.createdByUser = null;
    }
  }

  isActive(): boolean {
    return this.status === ConnectorStatus.ACTIVE;
  }

  isError(): boolean {
    return this.status === ConnectorStatus.ERROR;
  }
}
